export const ZD_DIRECTORY_ID = '-1';
export const ZD_TEST_DIRECTORY_ID = '-2';

export const INSURANCE_TYPES = {
    DENTAL: 1,
    HEALTH: 2,
    VISION: 3,
};
export const THEME_ROOT_KEY = 'theme';
export const PARAMETERS_KEY = 'parameters';

export const SearchParameterToQuery = {
    address: 'address',
    carrierId: 'insurance_carrier',
    dayFilter: 'day_filter',
    directoryId: 'directory_id',
    excludeSpecialties: 'exclude_specialties',
    genderFilter: 'gender',
    ip: 'ip',
    languageId: 'language',
    name: 'name',
    pageOffset: 'offset',
    planId: 'insurance_plan',
    practiceId: 'practiceId',
    procedureId: 'reason_visit',
    showProvidersWhoSeeChildren: 'sees_children',
    showTimesAfter5: 'after_5pm',
    showTimesBefore10: 'before_10am',
    sortType: 'sort_type',
    specialtyId: 'dr_specialty',
};
